/**
 * Journal: what was happening around baby's movements.
 * Tags are one-tap, the note is optional free text. Nothing here is ever
 * interpreted as a health signal (DECISIONS D6); Wrapped only says things like
 * "baby often moved after music", never "music makes baby move".
 */

/**
 * DRAFT list (2026-10-26) so the flow can be tried. Dew is collecting the real
 * list from mothers; replace ids/emoji here and labels in i18n `tags.*`.
 * Ids are stored in the database, so never rename an id once it's live:
 * add a new one and stop showing the old one instead.
 */
export const TAGS = [
  { id: 'after_meal', emoji: '🍚' },
  { id: 'sweet_cold', emoji: '🧊' },
  { id: 'music', emoji: '🎵' },
  { id: 'voice', emoji: '🗣️' },
  { id: 'resting', emoji: '🛋️' },
  { id: 'bedtime', emoji: '🌙' },
  { id: 'walking', emoji: '🚶‍♀️' },
  { id: 'bath', emoji: '🛁' }
] as const;

export type TagId = (typeof TAGS)[number]['id'];
export const NOTE_MAX = 500;

export interface JournalEntry {
  clientId: string;
  occurredAt: number;     // epoch ms
  tags: string[];         // TagId values; kept as string so retired ids still load
  note: string | null;
}

/** Normalise what the sheet produced; null if there is nothing worth saving. */
export function makeEntry(clientId: string, occurredAt: number, tags: string[], note: string): JournalEntry | null {
  const known = new Set<string>(TAGS.map(t => t.id));
  const cleanTags = [...new Set(tags)].filter(t => known.has(t)).slice(0, 8);
  const cleanNote = note.trim().slice(0, NOTE_MAX);
  if (!cleanTags.length && !cleanNote) return null;
  return { clientId, occurredAt, tags: cleanTags, note: cleanNote || null };
}
